<router-outlet disableRightClick />
<app-dev-bypass-helper></app-dev-bypass-helper>
<sura-mobility-loader *ngIf="loaderService.loading$ | async"></sura-mobility-loader>
